// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8072fe4c","498":"85556f86","513":"4a05f99c"}[chunkId] + ".chunk.js";
};